<template>
  <section id="contact">
    <vue-headful
        :title="$t('pages.contact') + ' - Fernando Mata'"
      />
    <article class="post" v-if="!hasSent">
      <h2>{{ $t('contact.title') }}</h2>
      <p>{{ $t('contact.subtitle') }}</p>
      <a :href="createURL()">{{ $t('contact.email') }}</a>
      <br />
      <br />
      <p>{{ $t('contact.userForm') }}</p>
      <!-- This contact form has a h0n3-yp0tt, check CSS -->
      <form class="form" v-on:submit.prevent="onSubmit()">
        <div class="nameField">
          <h4 v-bind:class="{'is-danger': errors.has('name')}">{{$t('contact.form.name')}}</h4>
          <div class="control">
            <input
              class="input"
              name="name"
              v-model="form.name"
              v-validate="'required|alpha'"
              type="text"
            />
          </div>
        </div>
        <div class="contactPhone">
          <h4>{{$t('contact.form.phone')}}</h4>
          <div class="control">
            <input
              class="input"
              name="phone"
              v-model="form.phone"
              v-validate="'max:0'"
              type="text"
              tabindex="-1"
              autocomplete="off"
            />
          </div>
        </div>
        <div class="contactMobile" v-show="!hasRendered">
          <h4>{{$t('contact.form.mobile')}}</h4>
          <div class="control">
            <input
              class="input"
              name="mobile"
              v-model="form.mobile"
              v-validate="'max:0'"
              type="text"
              tabindex="-1"
              autocomplete="off"
            />
          </div>
        </div>
        <div class="mailField">
          <h4 v-bind:class="{'is-danger': errors.has('mail')}">{{$t('contact.form.mail')}}</h4>
          <div class="control">
            <input
              class="input"
              name="mail"
              v-model="form.mail"
              v-validate="'required|email'"
              type="text"
            />
          </div>
        </div>
        <div class="subjectField">
          <h4 v-bind:class="{'is-danger': errors.has('subject')}">{{$t('contact.form.subject')}}</h4>
          <div class="control">
            <input
              class="input"
              name="subject"
              v-model="form.subject"
              v-validate="'required'"
              type="text"
            />
          </div>
        </div>
        <div class="contactField">
          <h4 v-bind:class="{'is-danger': errors.has('message')}">{{$t('contact.form.message')}}</h4>
          <div class="control">
            <textarea-autosize
              class="textarea"
              name="message"
              v-model="form.message"
              v-validate="'required'"
            />
          </div>
        </div>
        <p v-if="error" class="is-danger">{{$t('contact.tryagain')}}</p>
        <button class="is-primary" :disabled="isSending">{{$t('contact.form.send')}}</button>
      </form>
    </article>
    <article class="post" id="success" v-if="hasSent">
      <div id="successContent">
        <h2 v-if="!error">{{$t('contact.thankyou')}}</h2>
      </div>
    </article>
  </section>
</template>

<script>
export default {
  data() {
    return {
      form: {
        name: "",
        mail: "",
        subject: "",
        message: "",
        // These are our h0n3y-p0t values
        phone: "",
        mobile: ""
      },
      hasRendered: false,
      isSending: false,
      hasSent: false,
      error: false
    };
  },
  methods: {
    createURL() {
      return "mailto:" + this.$t("contact.email");
    },
    onSubmit() {
      this.$validator.validate().then(valid => {
        this.error = false;
        if (valid) {
          this.isSending = true;
          this.postForm(res => {
            if (res instanceof Error) {
              (this.isSending = false), 
              (this.error = true);
            } else {
              this.updateView;
            }
          });
        }
      });
    },
    updateView() {
      this.hasSent = true;
    },
    postForm(callback) {
      let sendURL = "https://fernandomt.com/en" + "/wp-json/contact/v1/send";
      let config = [
        "content/type : multipart/form-data"
      ];
      this.$http
        .post(sendURL, this.form, config)
        .then(response => {
          callback(response);
        })
        .catch(err => {
          callback(err);
        });
    }
  },
  mounted() {
    if (!this.hasRendered) {
      this.hasRendered = true;
    }
  }
};
</script>

<style scoped>
.form {
  width: 65%;
}
a {
  font-size: 1.5em;
}
.control {
  padding-bottom: 1em;
}
.contactPhone {
  opacity: 0;
  position: absolute;
  top: 0;
  left: 0;
  height: 0;
  width: 0;
  z-index: -1;
}
.is-danger {
  color: #e74c3c;
}
#success {
  height: 23.55em;
}
#successContent {
  text-align: center;
  position: absolute;
  top: 50%;
  left: 50%;
  margin-right: -50%;
  transform: translate(-50%, -50%);
}
</style>

